import useState from "react-usestateref";
import Header from "../Header/Header";
import "./contactus.css";
import wk_img_one from "../../assets/wk_img_one.webp";
import wk_img_two from "../../assets/wk_img_two.webp";
import wk_img_three from "../../assets/wk_img_three.webp";
import wk_img_four from "../../assets/wk_img_four.webp";
import wk_img_five from "../../assets/wk_img_five.webp";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import { toast } from "react-hot-toast";
import { postMethod } from "../../core/service/common.api"; // adjust path
import apiService from "../../core/service/detail";

const ContactUs = () => {
  const [formData, setFormData, formDataref] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const [errors, setErrors, errorsref] = useState({});
  const [loader, setLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  // input change handler
  const handleChange = (e) => {
    setFormData({
      ...formDataref.current,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errorsref.current,
      [e.target.name]: "",
    });
    validate();
  };

  // form validation
  const validate = () => {
    let tempErrors = {};

    // First Name
    if (!formDataref.current.firstName.trim()) {
      tempErrors.firstName = "First Name is required";
    } else if (formDataref.current.firstName.length < 2) {
      tempErrors.firstName = "First Name must be at least 2 characters";
    } else if (formDataref.current.firstName.length > 30) {
      tempErrors.firstName = "First Name cannot exceed 30 characters";
    }

    // Email
    if (!formDataref.current.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formDataref.current.email)) {
      tempErrors.email = "Invalid email format";
    }

    // Message
    if (!formDataref.current.message.trim()) {
      tempErrors.message = "Message is required";
    } else if (formDataref.current.message.length < 10) {
      tempErrors.message = "Message must be at least 10 characters";
    } else if (formDataref.current.message.length > 500) {
      tempErrors.message = "Message cannot exceed 500 characters";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // API call
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoader(true);
      setSuccessMsg("");

      const payload = {
        firstName: formDataref.current.firstName,
        lastName: formDataref.current.lastName,
        email: formDataref.current.email,
        message: formDataref.current.message,
      };

      const data = {
        apiUrl: apiService.createcontact, // replace with your actual API endpoint
        payload: payload,
      };

      const resp = await postMethod(data);
      setLoader(false);

      if (resp?.status === true) {
        toast.success(resp?.message);
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
      } else {
        toast.error(resp?.message);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error("Error occurred. Please try again later.");
    }
  };

  return (
    <div>
      <Header />
      <div className="main_page_wrp">
        <div className="contct-main-wrp">
          <h5>
            Contact <span>Us</span>
          </h5>
          <section>
            <div className="row contact-row">
              {/* left content */}
              <div className="col-12 col-lg-6">
                <div className="contact-content">
                  <h4>
                    Ready to step into the{" "}
                    <span>digital era with Assetly?</span>
                  </h4>
                  <p>
                    Our team is here to guide you every step of the way. Whether
                    you’re an investor looking for opportunities, an institution
                    exploring tokenization, or a partner interested in
                    collaboration, we’d love to hear from you. Reach out to us
                    today and let’s build the future of finance together.
                  </p>
                </div>
                <div className="contact_img_wrp">
                  <div className="contact_img">
                    <img src={wk_img_one} alt="wk_img" />
                  </div>
                  <div className="contact_img">
                    <img src={wk_img_three} alt="wk_img" />
                  </div>
                  <div className="contact_img">
                    <img src={wk_img_two} alt="wk_img" />
                  </div>
                  <div className="contact_img">
                    <img src={wk_img_four} alt="wk_img" />
                  </div>
                  <div className="contact_img">
                    <img src={wk_img_five} alt="wk_img" />
                  </div>
                </div>
              </div>

              {/* right form */}
              <div className="col-12 col-lg-6">
                <div className="contct_form_card">
                  <div className="form_notes">
                    <p>Please fill in all required fields</p>
                  </div>
                  <form className="contact_form" onSubmit={handleSubmit}>
                    <div className="form_group">
                      <input
                        type="text"
                        className="form_input"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder="First Name*"
                      />
                      {errorsref.current.firstName && (
                        <span className="error mt-2 d-block">
                          {errorsref.current.firstName}
                        </span>
                      )}
                    </div>
                    <div className="form_group">
                      <input
                        type="text"
                        className="form_input"
                        name="lastName"
                        value={formDataref.current.lastName}
                        onChange={handleChange}
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="form_group">
                      <input
                        type="text"
                        className="form_input"
                        name="email"
                        value={formDataref.current.email}
                        onChange={handleChange}
                        placeholder="Email*"
                      />
                      {errorsref.current.email && (
                        <span className="error mt-2 d-block">{errorsref.current.email}</span>
                      )}
                    </div>
                    <div className="form_group">
                      <textarea
                        name="message"
                        className="form_textarea"
                        value={formDataref.current.message}
                        onChange={handleChange}
                        placeholder="Message*"
                      />
                      {errorsref.current.message && (
                        <span className="error">
                          {errorsref.current.message}
                        </span>
                      )}
                    </div>

                    <button className="form_submit" disabled={loader}>
                      {loader ? "Sending..." : "Send Message"}
                    </button>
                  </form>

                  {successMsg && <p className="form_success">{successMsg}</p>}

                  <p className="form_description">
                    By clicking, you agree to receive communications from
                    Assetly in accordance with our <Link>Privacy Policy.</Link>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="mt-5">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
